import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import _get from 'lodash.get'

import apiChannel from 'api/company/channels'
import { ButtonTag } from 'components/Form'

const CHECK_NULL_VALUES = [null, undefined, '']

export function notRenderSendConnectionAPIToken(config, channel, operatorRole) {
  const { fieldForDisplay, allowedRole = [] } = config

  if (!fieldForDisplay.length) return true
  if (!allowedRole.includes(operatorRole)) return true
  if (fieldForDisplay.findIndex(f => CHECK_NULL_VALUES.includes(_get(channel, f))) !== -1) return true

  return false
}

/**
 * SendConnectionAPIToken
 * @param {object} props
 * @param {object} props.channel Current channel values
 * @param {object} props.config Current field config
 */
const SendConnectionAPIToken = (props) => {
  const { channel, config, className, description } = props

  const operatorSessionRole = useSelector(store => store.user.role)
  const [sending, setSending] = useState(false)

  if (notRenderSendConnectionAPIToken(config, channel, operatorSessionRole)) return null

  async function onClick() {
    if (sending) return
    setSending(true)

    try {
      await apiChannel.postSendConnectionAPIToken()

      toast(I18n.t('channel_send_email_api_token_right'), { autoClose: 4000, position: 'top-center' })
      setSending(false)
    } catch({ response, status }) {
      const data = _get(response, 'data', {})

      if (status !== 401) {
        toast(I18n.t(data.type || 'generic_error'), { autoClose: 4000 })

        setSending(false)
      }
    }
  }

  return (
    <div className={`channel-field input ${className ? className : ''}`}>
      {/* {label && <label htmlFor={id}>{I18n.t(label)}</label>} */}
      <div className={`field-content ${!className ? 'grid grid--large' : ''}`}>
        <ButtonTag
          size='large'
          //color='secondary'
          //style={{marginBottom: 12}}
          onClick={onClick}
          isSubmitting={sending}
          value={I18n.t('channel_send_email_api_token')}
        />
        {description && <p className='description'>{I18n.t(description)}</p>}
      </div>
    </div>
  )
}

export default SendConnectionAPIToken
